import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.roles.add', {
        url: '/add',
        views: {
            '@company.manage-application': 'companyManageApplicationRolesAdd',
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/add/add-role.state.js